// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZjsM4","wrapper":"styles_wrapper__4fEB5","title":"styles_title__Yo+BU","description":"styles_description__QEX0g","image":"styles_image__7cRyQ"};